import React, { memo } from 'react';

import TreeView from '@material-ui/lab/TreeView';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import CurrentStatus from 'components/atoms/CurrentStatus';

const MenuTree = (props) => {
  const { handleNodeSelect, renderTree, mainMenuList, loading } = props;
  return (
    <>
      <TreeView
        defaultCollapseIcon={<ExpandMoreIcon />}
        defaultExpanded={['root']}
        defaultExpandIcon={<ChevronRightIcon />}
        multiSelect
        onNodeSelect={handleNodeSelect}
        // onNodeToggle={handleToggle}
      >
        {renderTree(mainMenuList)}
      </TreeView>
      {loading && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgb(255 255 255 / 80%)',
          }}
        >
          <div style={{ marginTop: 200 }}>
            <CurrentStatus />
          </div>
        </div>
      )}
    </>
  );
};

const equalMemo = (prevProps, nextProps) => {
  return !(
    JSON.stringify(prevProps.mainMenuList) !==
      JSON.stringify(nextProps.mainMenuList) ||
    JSON.stringify(prevProps.loading) !== JSON.stringify(nextProps.loading)
  );
};

export default memo(MenuTree, equalMemo);
